export const classes = {
  wrapper: 'mb-4',
  header: 'flex items-baseline justify-between pl-1 pr-3 mb-2',
  sectionLabel:
    'text-xs uppercase tracking-wide text-grey-7 dark:text-mauve-2 font-semibold select-none',
  toggleAllButton:
    'relative bottom-px text-xs font-medium text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1 underline cursor-pointer',
  list: 'flex flex-col gap-1 px-1',
};
